const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  tbShake ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coin/v1frontend/mission/tb-shake', {
      params,
      noShowError: true,
    })
  },
  priceCompFirst ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coin/v1frontend/mission/price-comp-first', {
      params,
      noShowError: true,
    })
  },
  priceCompBought ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coin/v1frontend/mission/price-comp-bought', {
      params,
      noShowError: true,
    })
  },
  prepare ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coin/v1frontend/mission/prepare', {
      params,
      noShowError: true,
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
